import React from "react"
import { graphql } from "gatsby"
import AniLink from "gatsby-plugin-transition-link/AniLink"

import HomepageHero from "../components/sections/homepage-hero/homepage-hero"
import ImageText from "../components/sections/image-text/image-text"

import Layout from "../components/theme/theme"

import "../components/sections/section/section.css"
import "../components/sections/section/circle-list.css"

const IndexPage = props => {
  const sources = [
    props.data.mobileHero.childImageSharp.fluid,
    {
      ...props.data.desktopHero.childImageSharp.fluid,
      media: `(min-width: 768px)`,
    },
  ]

  return (
    <Layout>
      <HomepageHero image={sources} />

      <section className="sec-Section sec-Section-dark">
        <div className="sec-Section_Inner lyt-Container">
          <div className="sec-Section_Header">
            <h2 className="sec-Section_Title">
              An introduction to CBW Limited
            </h2>
          </div>

          <div className="sec-Section_Body">
            <p>CBW Ltd are a family run building and maintenance firm with an extensive knowledge and understanding of our industry. Since establishment in 2001, we have maintained a reputable, long-standing relationship with a number of regular clients and have continued to provide a high standard of services throughout.</p>
            
            <p>We aim to provide a fully managed, friendly and reliable service with a single point of contact for all of your requirements. CBW Ltd directly employ a team of skilled Tradesmen, with an experienced management team and dedicated office support team enabling all work to be undertaken in a swift and professional manner.</p>

            <AniLink
                cover
                bg="#22242b"
                direction="up"
                to="/services"
                className="sec-ImageText_Button btn-Primary btn-Primary-yellow">
                Check out our services
              </AniLink>
          </div>
        </div>
      </section>

      <ImageText theme="light" subtitle="Process" title="CBW Limited aims to provide a fully managed service" content={`<p>CBW Limited aim to provide a single point of contact for all your building and maintenance requirements. We strive to provide a fully managed product, from the initial point of contact through to completion.</p>`} buttonLink="/process" buttonText="See how it's done" image={props.data.drillImage.childImageSharp.fluid} />
    </Layout>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query {
    desktopHero: file(relativePath: { eq: "hero.jpg" }) {
      ...fluidImage
    }
    mobileHero: file(relativePath: { eq: "hero-mobile.jpg" }) {
      ...fluidImage
    }
    drillImage: file(relativePath: { eq: "homepage-drill.jpg" }) {
      ...fluidImage
    }
  }
`;

export const fluidImage = graphql`
  fragment fluidImage on File {
    childImageSharp {
      fluid(maxWidth: 2880) {
        ...GatsbyImageSharpFluid
      }
    }
  }
`
